import { z } from 'zod';
import { PreSurveySchema } from './presurvey.model';
import { SurveySchema } from "./survey.model";
import { ProjectUserSchema } from './user.model';

const MultiPolygonSchema = z.object({
  type: z.literal('MultiPolygon'),
  coordinates: z.array(z.array(z.array(z.array(z.number()))))
});

const ProjectGeometrySchema = MultiPolygonSchema;

export const ProjectSummarySchema = z
  .object({
    id: z.number(),
    name: z.string(),
    description: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    geometry: ProjectGeometrySchema.nullable(),
    ukHabVersion: z.string(),
    organisationId: z.number()
  })
  .strict();

export const ProjectVerificationStateSchema = z.object({
  stateId: z.number(),
  name: z.string(),
  color: z.string()
});
export type ProjectVerificationState = z.infer<typeof ProjectVerificationStateSchema>;

export type ProjectSummary = z.infer<typeof ProjectSummarySchema>;

export const ProjectDetailsSchema = ProjectSummarySchema.extend({
  role: z.string(),
  shareableLink: z.string(),
  states: ProjectVerificationStateSchema.array(),
  ukhabSharePassword: z.string().nullable().optional()
}).strict();

const ProjectMembershipSchema = z.object({
  role: z.string(),
  userId: z.number()
});

export type ProjectDetails = z.infer<typeof ProjectDetailsSchema>;
export type ProjectGeometry = z.infer<typeof ProjectGeometrySchema>;
export type Project = ProjectDetails & {
  surveys: z.infer<typeof SurveySchema>[];
  users: z.infer<typeof ProjectUserSchema>[];
  presurveys: z.infer<typeof PreSurveySchema>[];
  states: ProjectVerificationState[];
}

export type ProjectUpdate = Partial<Pick<ProjectDetails, 'name' | 'description' | 'geometry'>>;

export type ProjectMembership = z.infer<typeof ProjectMembershipSchema>;

export const ProjectMapLayerSchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.string(),
  bounds: z.array(z.number()).length(4),
  sort: z.number(),
  type: z.union([z.literal('image'), z.literal('geojson')]),
  style: z.object({
    color: z.string().optional(),
    opacity: z.number().optional(),

    pointRadius: z.number().optional(),
    pointOpacity: z.number().optional(),
    pointBorderColor: z.string().optional(),
    pointBorderWidth: z.number().optional(),
    pointBorderOpacity: z.number().optional(),

    lineWidth: z.number().optional(),
    lineOpacity: z.number().optional(),

    polygonOpacity: z.number().optional(),
    polygonBorderColor: z.string().optional(),
    polygonBorderWidth: z.number().optional(),
    polygonBorderOpacity: z.number().optional()
  }).passthrough()
}).strict();

export type ProjectMapLayer = z.infer<typeof ProjectMapLayerSchema>;
